// extracted by mini-css-extract-plugin
export var button = "_44-7";
export var buttonRow = "_44-6";
export var fadeIn = "_44-1";
export var gradient = "_44-0";
export var panel = "_44-2";
export var panelIn = "_44-3";
export var subtitle = "_44-5";
export var title = "_44-4";